module.exports = __webpack_public_path__ + "static/img/ExportDrawback.98ecce53.jpg";